/**
 * Where each role's "home" is.
 *
 * #350/#349: the insurer portal has its own dashboard at /insurer/dashboard.
 * The shared /dashboard is the broker/customer/POSP dashboard -- an insurer
 * opening it saw broker widgets with empty or wrong numbers. Every way home
 * (the Sidebar's Dashboard link, `/`, the insurer login, /dashboard itself)
 * resolves through this one function so they cannot drift apart.
 *
 * Every other role is unchanged: their home is still /dashboard.
 */

export const INSURER_ROLES: readonly string[] = ['insurer_admin', 'insurer_employee'];

export const INSURER_HOME = '/insurer/dashboard';
export const DEFAULT_HOME = '/dashboard';

/** Channel partner portal (phase 1): a partner has their own, separate home. */
export const PARTNER_ROLE = 'channel_partner';
export const PARTNER_HOME = '/partner';

/** #366: where insurer staff sign in (and are returned to on sign-out). */
export const INSURER_LOGIN_PATH = '/login/insurer';

export function isInsurerRole(role: string | null | undefined): boolean {
  return !!role && INSURER_ROLES.includes(role);
}

export function homePathForRole(role: string | null | undefined): string {
  if (role === PARTNER_ROLE) return PARTNER_HOME;
  return isInsurerRole(role) ? INSURER_HOME : DEFAULT_HOME;
}
